import { Box } from 'app/design/primitives/box';
import { ActivityIndicator } from 'react-native';

export function SavingsLoadingView({ containerWidth }: Readonly<{ containerWidth: number }>) {
  return (
    <Box alignSelf="center" width={containerWidth}>
      <ActivityIndicator />
    </Box>
  );
}
